var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { unpackPhoneVerification, unpackSandboxState, unpackWebhookEvents, } from "@/api/sandbox/sandbox.mapper";
import { MPInstanceSandbox } from "@/api/RequestAxios/RequestAxiosSandbox";
var sandboxStateUrl = function () { return "/state"; };
var verificationUrl = function () { return "/verification/initiate"; };
var webhookConfigUrl = function () { return "/configs/webhook"; };
export var messagesUrl = function () { return "/messages"; };
var webhookEventsUrl = function () { return "/webhook-events"; };
export var initiatePhoneVerification = function (queryParams) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.post(verificationUrl(), queryParams)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackPhoneVerification(data)];
        }
    });
}); };
export var getSandbox = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.get(sandboxStateUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackSandboxState(data)];
        }
    });
}); };
export var deleteSandbox = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.delete(sandboxStateUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var sendMessage = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.post(messagesUrl(), args)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var updateWebhookUrl = function (args) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.post(webhookConfigUrl(), args)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getWebhookUrl = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.get(webhookConfigUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getWebhookEvents = function (queryParams) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceSandbox.buffedInstances.get(webhookEventsUrl(), { params: queryParams })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackWebhookEvents(data)];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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